import Base from "./Base"
import Spin from "./Spin"
import styles from './styles.module.scss'

interface SpinnerLogoInterface {
  className?: string
  style?: any
}

const SpinnerLogo: React.FC<SpinnerLogoInterface> = ({ style = {} }) => {
  return <div className={styles.spinnerLogo} style={style}>
    <Base />
    <Spin />
  </div>
}

export default SpinnerLogo